import { c as _c } from "react/compiler-runtime";
import { type MemberDirectoryPageContent } from '../get-member-directory-page-content';
import styles from './no-results-card.module.scss';
export const NoResultsCard = t0 => {
  const $ = _c(7);
  const {
    cmsContent
  } = t0;
  let t1;
  if ($[0] !== cmsContent.noResultsTitle) {
    t1 = <p className={styles["card__message-title"]}>{cmsContent.noResultsTitle}</p>;
    $[0] = cmsContent.noResultsTitle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== cmsContent.noResultsMessage) {
    t2 = <p className={styles.card__message}>{cmsContent.noResultsMessage}</p>;
    $[2] = cmsContent.noResultsMessage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={styles.card}>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};